/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_DASHBOARD_TRANSACTIONS = `${url}/LOAD_DASHBOARD_TRANSACTIONS`;
export const LOAD_DASHBOARD_TRANSACTIONS_SUCCESS = `${url}/LOAD_DASHBOARD_TRANSACTIONS_SUCCESS`;
export const LOAD_DASHBOARD_TRANSACTIONS_ERROR = `${url}/LOAD_DASHBOARD_TRANSACTIONS_ERROR`;
export const LOAD_ACCESS = `${url}/LOAD_ACCESS`;
export const LOAD_ACCESS_SUCCESS = `${url}/LOAD_ACCESS_SUCCESS`;
export const LOAD_ACCESS_ERROR = `${url}/LOAD_ACCESS_ERROR`;
export const LOAD_MENU_LIST = `${url}/LOAD_MENU_LIST`;
export const LOAD_MENU_LIST_SUCCESS = `${url}/LOAD_MENU_LIST_SUCCESS`;
export const LOAD_MENU_LIST_ERROR = `${url}/LOAD_MENU_LIST_ERROR`;
export const LOAD_USER_ROLE_LIST = `${url}/LOAD_USER_ROLE_LIST`;
export const LOAD_USER_ROLE_LIST_SUCCESS = `${url}/LOAD_USER_ROLE_LIST_SUCCESS`;
export const LOAD_USER_ROLE_LIST_ERROR = `${url}/LOAD_USER_ROLE_LIST_ERROR`;
export const LOAD_USER_PERMISSON_LIST = `${url}/LOAD_USER_PERMISSON_LIST`;
export const LOAD_USER_PERMISSON_LIST_SUCCESS = `${url}/LOAD_USER_PERMISSON_LIST_SUCCESS`;
export const LOAD_USER_PERMISSON_LIST_ERROR = `${url}/LOAD_USER_PERMISSON_LIST_ERROR`;
export const LOAD_INFO_LIST = `${url}/LOAD_INFO_LIST`;
export const LOAD_INFO_LIST_SUCCESS = `${url}/LOAD_INFO_LIST_SUCCESS`;
export const LOAD_INFO_LIST_ERROR = `${url}/LOAD_INFO_LIST_ERROR`;
export const LOAD_USER_ACCESS = `${url}/LOAD_USER_ACCESS`
export const LOAD_USER_ACCESS_SUCCESS = `${url}/LOAD_USER_ACCESS_SUCCESS`
export const LOAD_USER_ACCESS_ERROR = `${url}/LOAD_USER_ACCESS_ERROR`
export const LOAD_USER_MENU = `${url}/LOAD_USER_MENU`
export const LOAD_USER_MENU_SUCCESS = `${url}/LOAD_USER_MENU_SUCCESS`
export const LOAD_USER_MENU_ERROR = `${url}/LOAD_USER_MENU_ERROR`

const constants = {
  LOAD_ACCESS,
  LOAD_ACCESS_SUCCESS,
  LOAD_ACCESS_ERROR,
  LOAD_DASHBOARD_TRANSACTIONS,
  LOAD_DASHBOARD_TRANSACTIONS_SUCCESS,
  LOAD_DASHBOARD_TRANSACTIONS_ERROR,
  LOAD_MENU_LIST,
  LOAD_MENU_LIST_SUCCESS,
  LOAD_MENU_LIST_ERROR,
  LOAD_USER_ROLE_LIST,
  LOAD_USER_ROLE_LIST_SUCCESS,
  LOAD_USER_ROLE_LIST_ERROR,
  LOAD_USER_PERMISSON_LIST,
  LOAD_USER_PERMISSON_LIST_SUCCESS,
  LOAD_USER_PERMISSON_LIST_ERROR,
  LOAD_INFO_LIST,
  LOAD_INFO_LIST_SUCCESS,
  LOAD_INFO_LIST_ERROR,
  LOAD_USER_ACCESS,
  LOAD_USER_ACCESS_SUCCESS,
  LOAD_USER_ACCESS_ERROR,
  LOAD_USER_MENU,
  LOAD_USER_MENU_SUCCESS,
  LOAD_USER_MENU_ERROR
};

export default constants;
